/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ account: NonNullable<unknown> }} Notice_BookedInputs */

const en_notice_booked = /** @type {(inputs: Notice_BookedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} booked`)
};

/**
* | output |
* | --- |
* | "{account} booked" |
*
* @param {Notice_BookedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notice_booked = /** @type {((inputs: Notice_BookedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notice_BookedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notice_booked(inputs)
});